// UAT
// export const API_URL = 'https://registration-forms-api-2026.maharashtracet.org';
// export const API_URL = 'https://registration-forms-api-2026.maharashtracet.org';
export const API_URL = 'https://mhcet-reg-uat1.hubblehox.ai/api';
// export const API_URL = 'http://172.16.57.102:3001';
export const FORM_ASYNC_API_URL = 'https://mhcet-async-api-uat.hubblehox.ai/async-api';
// mhcet-notification-service: email templates, sending by upload, send jobs (Email role)
export const NOTIFICATION_API_URL = 'https://mhcet-reg-uat1-notification.hubblehox.ai';
// export const NOTIFICATION_API_URL = 'http://localhost:3005';
export const NODE_ENV = 'production'

// Candidate dump download opens the folder in the GCP console rather than
// handing out a signed URL — the user signs in to GCP and picks the zip.
// Must match PRIVATE_BUCKET_NAME / projectId used by forms-async-api.
export const DUMP_BUCKET_NAME = 'mhcet-candidate-dump';
export const DUMP_GCP_PROJECT_ID = 'mhcet-registration-forms';
export const DUMP_BASE_PREFIX = 'allCandidatesDumpUsingCourseid';


// DEV
// export const API_URL = 'https://mhcet-reg-dev.hubblehox.ai/api';
// export const API_URL = 'http://172.16.57.72:3001';    
// export const NODE_ENV = 'production'
 
// LOCAL
// export const API_URL = 'http://localhost:3001';
// export const NODE_ENV = 'production'
 
 
export const AES_KEY = "0a1a57889030315bd571c8f72ba1c3b2ea811e2de93b9e34a4e2e3e88cba2c7a";
export const AES_IV = "76c2b153ff33ba05d5cfaa1ece032868";
// TEST
// export const API_URL = 'https://mhcet-test.praathee.in/api';
// export const NODE_ENV = 'production'
 
export const SHOW_RECONCILATION_REPORT = false;

export const preferenceReportAllowedUsers = ["46"];

export const searchCandidateAllowedUsers = ["48"];

export const restrictedUserId = ["45" , "50"];

export const generatePDFAllowedUsers = ["39"];
 
export const itemsPerPage = 5;